import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const EgitimlerPage = lazy(() => import('../pages/egitimler/page'));
const HakkimizdaPage = lazy(() => import('../pages/hakkimizda/page'));
const IletisimPage = lazy(() => import('../pages/iletisim/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    Component: HomePage,
  },
  {
    path: '/egitimler',
    Component: EgitimlerPage,
  },
  {
    path: '/hakkimizda',
    Component: HakkimizdaPage,
  },
  {
    path: '/iletisim',
    Component: IletisimPage,
  },
  {
    path: '/blog',
    Component: BlogPage,
  },
  {
    path: '*',
    Component: NotFoundPage,
  },
];

export default routes;
